// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/All-Products/Mesojet.png";
import thumb1 from "../assets/images/New-Products/Mesojet1.png";
import thumb2 from "../assets/images/All-Products/Mesojet.png";
import thumb3 from "../assets/images/New-Products/Mesojet2.png";
import howToUseThumb from "../assets/images/medical-bredcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/medical-bredcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("product_highlights");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Engineering the Future of Medical Precision"
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Medical Engineering", to: "/MedicalEnggProducts" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Mesojet</h2>
              <p className="sub-heading text-muted">Refreshed skin With Advanced Hydroporation Treatment</p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>Mesojet provides supersonic painless technology for transcutaneous supplementation.</li>
                  <li>Allows practitioners to administer a range of non-invasive, relaxing skin care procedures with outstanding results.</li>
                  <li>Advanced therapy for performing lymphatic drainage through exfoliation to needle-free sub-dermal delivery of actives.</li>
                  <li>The refreshing jet stimulates microcirculation, tones the skin, and reduces puffy areas.</li>
                </ul>

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Mesojet</span>
                </h3>
                <p>
                  MesoJet is a needle-free device used in clinics to cleanse, infuse, and stimulate the skin or
                  scalp in a single session. After proper cleansing, the device delivers high-speed micro-jets of
                  selected active serums deep into the skin, enhancing absorption and efficacy
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["product_highlights", "indications", "handpiece_technology"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "product_highlights"
                    ? "Product Highlights"
                    : tab === "indications"
                      ? "Indications"
                      : tab === "handpiece_technology"
                        ? "Handpiece Technology"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "product_highlights" && (
                <div className="tab-content fade-in">
                  {/* <p><strong>1. Benefits</strong></p> */}
                  <h4>Science Behind</h4>
                  <ul>
                    <li>MesoJet uses the potential of kinetic energy to break solutions containing innovative exfoliating and rejuvenating actives into micro-droplets.</li>
                    <li>Gently stretches the skin, creating a ‘barophoresis’ effect that opens micro-canals allowing the actives to penetrate deeply into the skin.</li>
                  </ul>

                  <h4>Product Highlights</h4>
                  <ul>
                    <li>Supersonic acceleration (200 m/sec.)</li>
                    <li>Micronization (few microns) of droplets of cosmetic or medical solutions</li>
                    <li>Lymphatic drainage, exfoliation, and painless sub-dermal infusion of actives</li>
                  </ul>

                </div>
              )}
              {activeTab === "indications" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Hydra dermabrasion</li>
                      <li>Chemical peeling</li>
                      <li>Subdermal infusion</li>
                      <li>Bio-rejuvenation</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "handpiece_technology" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Premium handpiece</li>
                      <li>High pressure air cleaning system makes rapid & easy cleaning</li>
                      <li>Adjustable jet streams</li>
                      <li>12 times better penetration to dermis with handpiece placed at 5 mm distance from skin</li>
                    </ul>

                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
